"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconRecycledMaterials = function IconRecycledMaterials(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M23.124 9.46a1 1 0 0 1 1.658-.11l.074.11 5.713 9.896 1.551-.896v5.58l-4.83-2.79 1.547-.894-4.848-8.396-5.483 9.5-1.732-1zM11.03 26.71l4.84-2.79v5.58l-1.551-.894L9.472 37H21v2H7.74a1 1 0 0 1-.917-1.399l.051-.101 5.712-9.893zm23.596-.46 6.49 11.25a1 1 0 0 1-.753 1.494L40.25 39H28.84v1.79L24 38l4.84-2.79V37h9.678l-5.624-9.75z",
    clipRule: "evenodd"
  })));
};

export { IconRecycledMaterials, IconRecycledMaterials as default };
